import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'app works!';
}



// WEBPACK FOOTER //
// /Users/william/Documents/gitlab/stovokor/src/app/app.component.ts